import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useForm } from '@mantine/form';
import { TextInput } from '@mantine/core';
import { toast } from 'react-toastify';
import { Button, Sidebar, Layout, Content } from '@components';
import { useAuth } from '@unbooking/ui-auth';
import { Loader } from '@mantine/core';
import './styles.scss';

const LocalSignInPage: FC = () => {
  const { t } = useTranslation();
  const { authorize, logout, userEmail } = useAuth();
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (formData: { email: string }) => {
    setIsLoading(true);

    try {
      await authorize(formData.email);
    } catch (err: any) {
      toast(err.message, { type: 'error' })
    }

    setIsLoading(false);
  };

  const form = useForm<{ email: string }>({
    initialValues: {
      email: '',
    },
  });

  return (
    <Layout>
      <Sidebar username={userEmail ?? ''} logout={logout} hideInfo>
        <h3>{t('sidebar.signUp.intro')}</h3>
        <h2 className='title'>{t('sidebar.signIn.title')}</h2>
        <Trans
          i18nKey='sidebar.signIn.description'
          components={[<p className='description' key={0} />, <p className='description underline' key={1} />]}
        />
      </Sidebar>
      <Content>
        <h2 className='title'>{t('content.signIn.title')}</h2>
        <form className='form' onSubmit={form.onSubmit(onSubmit)}>
          <div className='row'>
            <TextInput
              className='input'
              type='email'
              label={t('content.signIn.email.title')}
              placeholder={t('content.signIn.email.placeholder')}
              required
              {...form.getInputProps('email')}
            />
          </div>
          <div className='center'>
            {isLoading ? <Loader size='md' /> :
              <Button
                className='btn-confirm'
                color='blue'
                disabled={!form.getInputProps('email').value}
                fullWidth
                text={t('content.signIn.submit')}
                type='submit'
                variant='filled'
              />
            }
          </div>
          {/* <div className='separator'>
            <hr />
            <span>{t('content.signIn.or')}</span>
            <hr />
          </div>

          <Button
            className='sign-up'
            color='white'
            fullWidth
            text={t('content.signIn.signUp')}
            variant='filled'
            onClick={() => {
              navigate('/local-sign-up', { replace: true });
            }}
          /> */}
        </form>
      </Content>
    </Layout>
  );
};

export default LocalSignInPage;
